module.exports = __webpack_public_path__ + "img/frc.2935f680.png";